/**
 * Navigates the page to `url`, as `window.location.assign` does. `location` is
 * unforgeable, so this module is the seam a spec mocks to observe navigation.
 *
 * @param {string} url
 */
export function navigateTo(url) {
  window.location.assign(url);
}
